export const mixinModel = {
  model: {
    prop: 'value',
    event: 'setMixinModelValue'
  },

  props: ['value'],

  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('setMixinModelValue', value);
      }
    }
  }
};
